/**
 * Every row of a paginated list endpoint ({count, next, results}, or a plain array from an unpaginated one).
 * `fetchPage({page, page_size})` loads one page. The first request asks for a big page, so a list of
 * usual size comes in one go (one page also stays consistent when the server's order is not unique);
 * the next pages follow while the server says there is one (`next`), whatever page size it allowed.
 */
export async function fetchAllPages(fetchPage, pageSize = 500) {
  let data = await fetchPage({ page: 1, page_size: pageSize });
  if (Array.isArray(data)) return data;
  const rows = [...(data?.results || [])];
  for (let page = 2; data?.next; page += 1) {
    data = await fetchPage({ page, page_size: pageSize });
    rows.push(...(data?.results || []));
  }
  return rows;
}
